import React from "react";
// Front Pages
import Home from "../pages/front/home/index";
import Vpeters from "../pages/front/vpeters/index";
import Apply from "../pages/front/apply/index";
import Projects from "../pages/front/projects/index";
import AllProjects from "../pages/front/allProjects/index";
import UpdatesAndBlogs from "../pages/front/updatesandblogs/index";
import Contact from "../pages/front/contact/index";
import TakeAction from "../pages/front/takeaction/index";
import PrivacyPolicy from "../pages/front/privacy/index";
import Blogs from "../pages/front/bloglist/index";
import Events from "../pages/front/eventList/index";
import BlogDetails from "../pages/front/blogdetails/index";
import Updates from "../pages/front/annoucementlist/index";
import UpdateDetails from "../pages/front/annoucementdetails/index";
import Terms from "../pages/front/terms/index";
import ProjectItem from "../pages/front/ProjectItem/index";

// Authentication Pages
import Authentication from "../pages/front/authentication/index";
import OtpVerification from "../pages/front/authentication/otpVerification";
import ResetPassword from "../pages/front/authentication/resetPassword";
import ForgotPassword from "../pages/front/authentication/forgotPassword";
import AdminLogin from "../pages/admin/signIn/AdminLogin";
import AcceptUser from "../pages/admin/reset-password/ResetPassword";
import AdminForgotPassword from "../pages/auth/ForgotPassword";

// Admin Pages
import AdminDashboard from "../pages/admin/Dashboard";
import Resource from "../pages/admin/resource/Resource";
import BlogList from "../pages/admin/BlogList";
import ProjectsAdmin from "../pages/admin/Projects";
import ScholarshipApplication from "../pages/admin/ScholarshipApplication";
import ScholarshipView from "../pages/admin/ScholarshipView";
import ScholarshipSubmittionView from "../components/sections/admin/scholarship/ViewSubmittionDetails";
import Faq from "../pages/admin/Faq";
import Eligibility from "../pages/admin/Eligibility";
import Banners from "../pages/admin/Banners";
import ManageBanner from "../components/sections/admin/banner/ManageBanner";
import Quiz from "../pages/admin/Quiz";
import AppForm from "../pages/admin/AppForm";
import Donation from "../pages/admin/Donation";
import Finances from "../pages/admin/Finances";
import Subscription from "../pages/admin/Subscription";
import Users from "../pages/admin/Users";
import CommunicationsAdmin from "../pages/user/Communications";
import Settings from "../pages/admin/Settings";
import Testimonials from "../pages/admin/Testimonials";
import Calendar from "../pages/admin/Calender";
import Question from "../pages/admin/Question";
import Pdf from "../pages/admin/Pdf";
import Publication from "../pages/admin/Publication";
import Category from "../pages/admin/Category";
import Partner from "../pages/admin/Partner";
import SiteSettings from "../pages/admin/Sitesetting";
import Pages from "../pages/admin/Pages";
import ScholarshipTimeline from "../pages/admin/ScholarshipTimeline";
import EmailTemplate from "../pages/admin/EmailTemplate";
import PaymentMethod from "../pages/admin/PaymentMethod";
import ContactUs from "../pages/admin/ContactUs";

// User Pages
import UserDashboard from "../pages/user/Dashboard";
import CommunicationsUser from "../pages/user/Communications";
import ProfileUser from "../pages/user/Profile";
import Applications from "../pages/user/Applications";
import ManageApplication from "../components/sections/admin/applicationForm/modals/ApplicationForm";
import UserDonation from "../pages/user/Donation";
import UserSubscription from "../pages/user/Subscription";

// Donor Page
import DonorDashboard from "../pages/donor/Dashboard";
import DonorSubscription from "../pages/donor/Subscription";

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//     component: component || React.lazy(() => import("../pages/auth/Login")),
//     layout: "auth"||"front"||"admin",
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//         component: component || React.lazy(() => import("../pages/employees/Manage")),
//         layout: "auth"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

export const frontRoutes = (data) => {
  return [
    {
      path: "/",
      title: "Home",
      component: Home,
      layout: "front",
    },
    {
      path: "/vpeters",
      title: "Vpeters",
      component: Vpeters,
      layout: "front",
    },
    {
      path: "/apply",
      title: "Apply",
      component: Apply,
      layout: "front",
    },
    {
      path: "/projects",
      title: "Projects",
      component: Projects,
      layout: "front",
    },
    {
      path: "/projects-list",
      title: "All Projects",
      component: AllProjects,
      layout: "front",
    },
    {
      path: "/updates-and-blogs",
      title: "Updates and Blogs",
      component: UpdatesAndBlogs,
      layout: "front",
    },
    {
      path: "/contact",
      title: "Contact",
      component: Contact,
      layout: "front",
    },
    {
      path: "/take-action",
      title: "Take Action",
      component: TakeAction,
      layout: "front",
    },
    {
      path: "/privacy-policy",
      title: "Privacy Policy",
      component: PrivacyPolicy,
      layout: "front",
    },
    {
      path: "/blogs",
      title: "Blogs",
      component: Blogs,
      layout: "front",
    },
    {
      path: "/events",
      title: "Events",
      component: Events,
      layout: "front",
    },
    {
      path: "/blogs/:slug",
      title: "Blog Details",
      component: BlogDetails,
      layout: "front",
    },
    {
      path: "/updates",
      title: "Updates",
      component: Updates,
      layout: "front",
    },
    {
      path: "/updates/:slug",
      title: "Update Details",
      component: UpdateDetails,
      layout: "front",
    },
    {
      path: "/terms",
      title: "Terms",
      component: Terms,
      layout: "front",
    },
    {
      path: "/project-item",
      title: "Project Item",
      component: ProjectItem,
      layout: "front",
    },
  ];
  // if (data?.roleCode !== "admin") {
  // } else {
  //   return [];
  // }
};

export const authRoutes = (data) => [
  {
    path: "/authentication",
    title: "Authentication",
    component: Authentication,
    routeType: "auth",
  },
  {
    path: "/authentication/donor",
    title: "Authentication",
    component: Authentication,
    routeType: "auth",
  },
  {
    path: "/account-verification",
    title: "OTP Verification",
    component: OtpVerification,
    routeType: "auth",
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: "auth",
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    routeType: "auth",
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  {
    path: "/accept-user",
    title: "Accept User",
    component: AcceptUser,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];

export const adminRoutes = (data) => {
  const routes_data = [
    {
      path: "/admin/dashboard",
      title: "dashboard",
      // code: "dashboard",
      layout: "admin",
      routeType: "admin",
      component: AdminDashboard,
    },
    {
      path: "/admin/resources",
      component: Resource,
      layout: "admin",
      routeType: "admin",
      title: "Resource",
      code: "resource",
    },
    {
      path: "/admin",
      title: "admin",
      code: "dashboard",
      layout: "admin",
      routeType: "admin",
      component: AdminDashboard,
    },
    {
      path: "/admin/blogs",
      title: "blogs",
      code: "blogs",
      layout: "admin",
      routeType: "admin",
      component: BlogList,
    },
    // {
    //   path: "/admin/news",
    // layout:"admin",
    // routeType: "admin",",
    // component: React.lazy(() => import("../pages/admin/News")),
    // },
    {
      path: "/admin/projects",
      title: "projects",
      code: "projects",
      layout: "admin",
      routeType: "admin",
      component: ProjectsAdmin,
    },
    {
      path: "/admin/scholarships",
      title: "scholarships",
      code: "scholarships",
      layout: "admin",
      routeType: "admin",
      component: ScholarshipApplication,
    },
    {
      path: "/admin/scholarship-application/list",
      title: "scholarship-application",
      code: "scholarshipApp",
      layout: "admin",
      routeType: "admin",
      component: ScholarshipView,
    },
    {
      path: "/admin/scholarship-application/list/view-submittion",
      title: "Scholarship-Submittion-View",
      code: "",
      layout: "admin",
      routeType: "admin",
      component: ScholarshipSubmittionView,
    },
    {
      path: "/admin/scholarship-application/list/:id",
      title: "scholarship-application",
      code: "scholarshipApp",
      layout: "admin",
      routeType: "admin",
      component: ScholarshipView,
    },
    {
      path: "/admin/faq",
      title: "faq",
      code: "faq",
      layout: "admin",
      routeType: "admin",
      component: Faq,
    },
    {
      path: "/admin/eligibility",
      title: "eligibility",
      code: "eligibility",
      layout: "admin",
      routeType: "admin",
      component: Eligibility,
    },
    {
      path: "/admin/pages",
      title: "pages",
      code: "pages",
      layout: "admin",
      routeType: "admin",
      component: Banners,
    },
    {
      title: "Pages Manage",
      path: "/admin/pages/manage",
      layout: "admin",
      code: "pages",
      routeType: "admin",
      component: ManageBanner,
    },
    {
      path: "/admin/quiz",
      title: "quiz",
      code: "eligibilityQuiz",
      layout: "admin",
      routeType: "admin",
      component: Quiz,
    },
    {
      path: "/admin/appForm",
      title: "application form",
      code: "appForms",
      layout: "admin",
      routeType: "admin",
      component: AppForm,
    },
    {
      path: "/admin/appform/manage",
      title: "App Forms",
      code: "appForms",
      layout: "admin",
      routeType: "admin",
      component: ManageApplication,
    },
    {
      path: "/admin/donations",
      title: "donations",
      code: "donations",
      layout: "admin",
      routeType: "admin",
      component: Donation,
    },
    {
      path: "/admin/finances",
      title: "finances",
      code: "fiances",
      layout: "admin",
      routeType: "admin",
      component: Finances,
    },
    {
      path: "/admin/subscription",
      title: "Subscription",
      code: "recurringDonations",
      layout: "admin",
      routeType: "admin",
      component: Subscription,
    },
    {
      path: "/admin/payment",
      title: "payment method",
      code: "paymentMethod",
      layout: "admin",
      routeType: "admin",
      component: PaymentMethod,
    },
    {
      path: "/admin/users",
      title: "users",
      code: "users",
      layout: "admin",
      routeType: "admin",
      component: Users,
    },
    // {
    //   path: "/admin/accesscontrol",
    //   title: "accesscontrol",
    //   code: "",
    //   layout: "admin",
    //   routeType: "admin",
    //   component: AccessControl,
    // },
    {
      path: "/admin/communications",
      title: "communications",
      code: "communications",
      layout: "admin",
      routeType: "admin",
      component: CommunicationsAdmin,
    },
    {
      path: "/admin/settings",
      title: "settings",
      code: "",
      layout: "admin",
      routeType: "admin",
      component: Settings,
    },
    {
      path: "/admin/testimonials",
      title: "testimonials",
      code: "testimonials",
      layout: "admin",
      routeType: "admin",
      component: Testimonials,
    },
    {
      path: "/admin/events",
      title: "events",
      code: "events",
      layout: "admin",
      routeType: "admin",
      component: Calendar,
    },
    {
      path: "/admin/questions",
      title: "questions",
      code: "questions",
      layout: "admin",
      routeType: "admin",
      component: Question,
    },
    {
      path: "/admin/:id/pdf",
      title: "pdf",
      code: "",
      layout: "admin",
      routeType: "admin",
      component: Pdf,
    },
    {
      path: "/admin/publications",
      title: "publications",
      code: "publications",
      layout: "admin",
      routeType: "admin",
      component: Publication,
    },
    {
      path: "/admin/:categoryType/categories",
      title: "categories",
      code: ["publicationCategories", "blogsCategories"],
      layout: "admin",
      routeType: "admin",
      component: Category,
    },
    {
      path: "/admin/partners",
      title: "partners",
      code: "partners",
      layout: "admin",
      routeType: "admin",
      component: Partner,
    },
    {
      path: "/admin/site-settings",
      title: "settings",
      code: "siteSettings",
      layout: "admin",
      routeType: "admin",
      component: SiteSettings,
    },
    {
      path: "/admin/sections",
      title: "sections",
      code: "sections",
      layout: "admin",
      routeType: "admin",
      component: Pages,
    },
    {
      path: "/admin/scholarship-timeline",
      title: "timeline",
      code: "timeline",
      layout: "admin",
      routeType: "admin",
      component: ScholarshipTimeline,
    },
    {
      path: "/admin/profile",
      title: "profile",
      code: "profile",
      layout: "admin",
      routeType: "admin",
      // component: ProfileAdmin,
      component: ProfileUser,
    },
    {
      path: "/admin/email-template",
      title: "Email Template",
      code: "emailTemplates",
      layout: "admin",
      routeType: "admin",
      component: EmailTemplate,
    },
    {
      path: "/admin/contact-us",
      title: "Contact Us",
      code: "contactUs",
      layout: "admin",
      routeType: "admin",
      component: ContactUs,
    },
  ];

  const withoutCode = routes_data?.filter((item) => !item?.code);
  const withCode = routes_data?.filter((item) => {
    if (item?.code) {
      if (typeof item?.code === "string") {
        return !(data?.inactiveRoutes || [])?.includes(item?.code);
      } else if (Array.isArray(item?.code)) {
        return item?.code?.some(
          (code) => !(data?.inactiveRoutes || [])?.includes(code)
        );
      }
    }
  });
  return [...withoutCode, ...withCode];
};

export const userRoutes = (data) => [
  {
    path: "/user",
    component: UserDashboard,
    routeType: "user",
    layout: "admin",
    title: "user-dashboard",
  },
  {
    path: "/user/dashboard",
    component: UserDashboard,
    routeType: "user",
    layout: "admin",
    title: "user-dashboard",
  },
  {
    path: "/user/communications",
    component: CommunicationsUser,
    routeType: "user",
    layout: "admin",
    title: "Communications",
  },
  {
    path: "/user/profile",
    component: ProfileUser,
    routeType: "user",
    layout: "admin",
    title: "Profile",
  },

  {
    path: "/user/applications",
    component: Applications,
    routeType: "user",
    layout: "admin",
    title: "Applications",
  },
  {
    path: "/user/resource-library",
    component: Resource,
    layout: "admin",
    routeType: "user",
    title: "Resource",
  },
  {
    path: "/user/donation",
    component: UserDonation,
    routeType: "user",
    layout: "admin",
    title: "user-dashboard",
  },
  {
    path: "/user/subscription",
    component: UserSubscription,
    routeType: "user",
    layout: "admin",
    title: "user-dashboard",
  },
  {
    path: "/user/:id/pdf",
    title: "User_Pdf",
    layout: "admin",
    routeType: "user",
    component: Pdf,
  },
];

export const donorRoutes = (data) => [
  {
    path: "/donor",
    component: DonorDashboard,
    routeType: "donor",
    layout: "admin",
    title: "user-dashboard",
  },
  {
    path: "/donor/:id/pdf",
    title: "Donor_Pdf",
    layout: "admin",
    routeType: "donor",
    component: Pdf,
  },
  {
    path: "/donor/donation",
    component: DonorDashboard,
    routeType: "donor",
    layout: "admin",
    title: "user-dashboard",
  },
  {
    path: "/donor/subscription",
    component: DonorSubscription,
    routeType: "donor",
    layout: "admin",
    title: "donor-dashboard",
  },
];

export const routerData = (data) => {
  return [
    ...userRoutes(data),
    ...adminRoutes(data),
    ...authRoutes(data),
    ...frontRoutes(data),
    ...donorRoutes(data),
  ];
};
